import RunsOverview from '../components/RunsOverview';
import { useSettingsContext } from '../context/SettingsContext';

export const RunsRoute = () => {
  const { runs, caseId } = useSettingsContext();

  return <RunsOverview runs={runs} caseId={caseId} />;
};
